export default "__VITE_ASSET__MpdHjw1X__"